<template>
  <div class="scheduling-section">
    <v-row>
      <v-col cols="12">
        <VueCronEditorBuefy
          v-model="form.cronSchedule"
          :visibleTabs="['hourly', 'daily', 'weekly', 'monthly']" />
      </v-col>
    </v-row>
    <v-row class="mt-4">
      <v-col cols="12">
        <div class="timezone-info">
          <v-icon small class="timezone-icon">mdi-clock-outline</v-icon>
          <span class="timezone-text">Timezone: {{ timezoneDisplayText }}</span>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>

import VueCronEditorBuefy from '../../../plugins/vue-cron-editor-buefy';
import DataService from '../../../../_services/DataService';

export default {
  name: 'MessageScheduling',
  props: ['pageData'],
  components: {
    VueCronEditorBuefy,
  },
  data() {
    return {
      timezoneDisplayText: '',
      defaultCron: '0 12 * * 1',
      form: {
        cronSchedule: '',
      },
    };
  },
  watch: {
    ['pageData.parent']: {
      handler() {
        this.setupParentRelationship();
      },
      deep: false,
    },
    ['pageData.parent.selectedTemplate']: {
      handler() {
        this.setScheduleFromTemplate();
      },
      deep: false,
    },
  },
  methods: {
    setupParentRelationship() {
      // eslint-disable-next-line
      this.pageData.parent.scheduleTab = this; // hack
    },
    setScheduleFromTemplate() {
      this.form.cronSchedule = this.pageData.parent.selectedTemplate.cronSchedule || this.defaultCron;
    },
    async loadTimezone() {
      const configResponse = await DataService.getConfigInfoById(DataService.getClientId());
      if (configResponse.status === 200) {
        this.timezoneDisplayText = configResponse.data.timezone;
      }
    },
  },
  async mounted() {
    await this.loadTimezone();

    if (this.pageData?.parent) {
      this.setupParentRelationship();

      if (this.pageData.parent.selectedTemplate) {
        this.setScheduleFromTemplate();
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';

$cron-tab-active-color: #B0D35E;
$cron-tab-text-color: #6b7280;
$cron-input-border-color: #e2e8f0;
$timezone-bg-color: #f8fafc;
$timezone-border-color: #e2e8f0;
$timezone-icon-color: #6b7280;
$timezone-text-color: #6b7280;

.scheduling-section {
  padding: 16px 0;
  
  @media (max-width: $breakpoint-mobile) {
    padding: 8px 0;
  }
}

.timezone-info {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background-color: $timezone-bg-color;
  border-radius: 8px;
  border: 1px solid $timezone-border-color;
  width: fit-content;
  margin-left: 24px;
  
  @media (max-width: $breakpoint-tablet-large) {
    margin-left: 16px;
  }
  
  @media (max-width: $breakpoint-mobile) {
    margin-left: 0;
    width: 100%;
    justify-content: center;
  }
  
  .timezone-icon {
    color: $timezone-icon-color;
  }
  
  .timezone-text {
    font-size: 14px;
    color: $timezone-text-color;
    font-weight: 500;
  }
}
</style>

<style lang="scss">
@import '@/scss/variables.scss';

$cron-tab-active-color: #B0D35E;
$cron-tab-text-color: #6b7280;
$cron-input-border-color: #e2e8f0;
$cron-tab-hover-bg: #f8fafc;
$cron-tab-hover-text: #4a5568;
$cron-tab-active-text: #133b54;
$cron-input-text-color: #1f2937;
$cron-select-text-color: #1f2937;
$cron-colon-color: #6b7280;
$checkbox-bg-color: #f8fafc;
$checkbox-border-color: #e2e8f0;
$checkbox-hover-bg: #edf2f7;
$checkbox-hover-border: #cbd5e0;
$checkbox-checked-color: #414a5b;
$checkbox-unchecked-border: #cbd5e0;
$checkbox-label-color: #1f2937;
$label-text-color: #6b7280;
$number-input-border: #e2e8f0;

.scheduling-section {
  .enable-bulma {
    .b-tabs {
      .tabs {
        margin-bottom: 20px;
        
        @media (max-width: $breakpoint-mobile) {
          margin-bottom: 16px;
        }
        
        ul {
          border-bottom: 2px solid #e2e8f0;
          display: flex;
          justify-content: space-around;
          
          @media (max-width: $breakpoint-mobile) {
            gap: 0;
          }
          
          li {
            flex: 1;
            
            @media (max-width: $breakpoint-mobile) {
              flex: 1;
              min-width: 0;
            }
            
            a {
              color: $cron-tab-text-color;
              font-weight: 500;
              text-transform: uppercase;
              font-size: 13px;
              letter-spacing: 0.05em;
              border-bottom: 3px solid transparent;
              margin-bottom: -2px;
              padding: 12px 20px;
              transition: all 0.2s ease;
              display: block;
              text-align: center;
              
              @media (max-width: $breakpoint-mobile) {
                padding: 12px 8px;
                font-size: 11px;
                letter-spacing: 0.03em;
                white-space: nowrap;
              }
              
              &:hover {
                color: $cron-tab-hover-text;
                background-color: $cron-tab-hover-bg;
              }
            }
            
            &.is-active a {
              color: $cron-tab-active-text;
              font-weight: 600;
              border-bottom-color: $cron-tab-active-color;
            }
          }
        }
      }
    }
    
    .field {
      margin-bottom: 0;
      
      @media (max-width: $breakpoint-mobile) {
        margin-bottom: 16px;
      }
      
      &.is-grouped {
        @media (max-width: $breakpoint-mobile) {
          flex-direction: column;
          align-items: stretch !important;
          gap: 12px;
        }
      }
      
      .control {
        @media (max-width: $breakpoint-mobile) {
          width: 100%;
          max-width: 100%;
        }
        
        input.input {
          border: 1px solid $cron-input-border-color;
          border-radius: 6px;
          padding: 8px 12px;
          font-size: 14px;
          color: $cron-input-text-color;
          transition: border-color 0.2s ease;
          min-height: 44px;
          
          @media (max-width: $breakpoint-mobile) {
            font-size: 16px;
            padding: 12px 16px;
            min-height: 48px;
            width: 100%;
          }
          
          &:focus {
            border-color: $cron-tab-active-color;
            box-shadow: 0 0 0 3px rgba(176, 211, 94, 0.1);
          }
          
          &[type="number"] {
            max-width: 70px;
            text-align: center;
            
            @media (max-width: $breakpoint-mobile) {
              max-width: 100%;
              min-height: 48px;
              text-align: left;
            }
          }
        }
      }
      
      .label {
        color: $label-text-color;
        font-size: 14px;
        font-weight: 500;
        margin-bottom: 4px;
        white-space: nowrap;
        
        @media (max-width: $breakpoint-mobile) {
          font-size: 15px;
          margin-bottom: 8px;
          white-space: normal;
          display: block;
          width: 100%;
        }
      }
    }

    // Timepicker dropdown fixes
    .timepicker {
      .dropdown.is-active::before {
        @media (max-width: $breakpoint-mobile) {
          content: '';
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          z-index: 9998;
        }
      }
      
      .dropdown-trigger {
        @media (max-width: $breakpoint-mobile) {
          width: 100%;
        }
        
        .control.has-icons-left {
          @media (max-width: $breakpoint-mobile) {
            width: 100%;
          }
          
          input.input {
            padding-left: 40px;
            
            &::-webkit-calendar-picker-indicator {
              display: none !important;
            }
          }
          
          .icon.is-left {
            left: 8px;
            height: 100%;
            display: flex;
            align-items: center;
            
            @media (max-width: $breakpoint-mobile) {
              left: 10px;
              width: 28px;
            }
          }
        }
      }
      
      .dropdown-menu {
        left: -20px !important;
        
        @media (max-width: $breakpoint-tablet-large) {
          position: fixed !important;
          top: 50% !important;
          left: 50% !important;
          transform: translate(-50%, -50%) !important;
          width: auto !important;
          max-width: 90vw !important;
          z-index: 9999 !important;
        }
        
        @media (max-width: $breakpoint-mobile) {
          position: fixed !important;
          left: 50% !important;
          top: 50% !important;
          transform: translate(-50%, -50%) !important;
          width: auto !important;
          max-width: 90vw !important;
          z-index: 9999 !important;
        }
        
        .dropdown-content {
          padding: 12px;
          max-height: 280px;
          overflow: hidden;
          
          @media (max-width: $breakpoint-mobile) {
            max-height: 320px;
          }
        }
      }
      
      .dropdown-item {
        padding: 8px;
        
        @media (max-width: $breakpoint-mobile) {
          padding: 12px;
          min-height: 44px;
        }
      }
      
      .field.is-grouped {
        justify-content: center;
        align-items: center;
        gap: 8px;
        
        @media (max-width: $breakpoint-mobile) {
          gap: 12px;
          flex-wrap: nowrap;
          justify-content: flex-start;
          flex-direction: row;
        }
        
        .control {
          @media (max-width: $breakpoint-mobile) {
            width: auto;
          }
          
          .select {
            select {
              max-height: 200px;
              border: 1px solid $cron-input-border-color;
              border-radius: 6px;
              padding: 6px 32px 6px 10px;
              font-size: 16px;
              font-weight: 500;
              color: $cron-select-text-color;
              min-height: 44px;
              
              @media (max-width: $breakpoint-mobile) {
                font-size: 18px;
                padding: 12px 36px 12px 16px;
                min-height: 48px;
              }
              
              &:focus {
                border-color: $cron-tab-active-color;
                box-shadow: 0 0 0 2px rgba(176, 211, 94, 0.1);
              }
            }
          }
        }
        
        .is-colon {
          font-size: 18px;
          font-weight: 600;
          color: $cron-colon-color;
          padding: 0 4px;
          
          @media (max-width: $breakpoint-mobile) {
            font-size: 20px;
            padding: 0 6px;
          }
        }
      }
    }
    
    // Weekly checkboxes mobile optimization
    .weekly-tab .card .field.has-addons {
      display: flex !important;
      flex-wrap: wrap !important;
      gap: 12px !important;
      
      .centered-text {
        width: 100% !important;
        font-size: 15px !important;
        font-weight: 500 !important;
        color: $label-text-color !important;
        
        &:first-child {
          margin-bottom: 8px !important;
        }
      }
      
      .centered-checkbox-group {
        width: 100% !important;
        display: grid !important;
        grid-template-columns: 1fr 1fr !important;
        gap: 8px !important;
        
        label.b-checkbox {
          padding: 10px 12px !important;
          margin: 0 !important;
          border: 1px solid $checkbox-border-color !important;
          border-radius: 6px !important;
          background-color: $checkbox-bg-color !important;
          min-height: 44px !important;
          display: flex !important;
          align-items: center !important;
          transition: all 0.2s ease !important;
          cursor: pointer !important;
          
          &:hover {
            background-color: $checkbox-hover-bg !important;
            border-color: $checkbox-hover-border !important;
          }
          
          input[type="checkbox"]:checked + .check {
            background-color: $checkbox-checked-color !important;
            border-color: $checkbox-checked-color !important;
          }
          
          .check {
            width: 20px !important;
            height: 20px !important;
            min-width: 20px !important;
            border: 2px solid $checkbox-unchecked-border !important;
            border-radius: 4px !important;
          }
          
          .control-label {
            font-size: 15px !important;
            margin-left: 10px !important;
            color: $checkbox-label-color !important;
          }
        }
      }
      
      .timepicker {
        width: 100% !important;
        margin-top: 8px !important;
      }
      
      @media (max-width: $breakpoint-mobile) {
        .centered-checkbox-group {
          grid-template-columns: 1fr !important;
          
          label.b-checkbox {
            padding: 12px 16px !important;
            min-height: 48px !important;
            
            .check {
              width: 24px !important;
              height: 24px !important;
              min-width: 24px !important;
            }
            
            .control-label {
              font-size: 16px !important;
              margin-left: 12px !important;
            }
          }
        }
      }
    }
    
    // Monthly tab mobile optimization
    .monthly-tab .card .field.has-addons {
      @media (max-width: $breakpoint-tablet-large) {
        display: flex !important;
        flex-direction: column !important;
        align-items: stretch !important;
        gap: 16px !important;
        
        .centered-text {
          width: 100% !important;
          text-align: left !important;
          font-size: 15px !important;
          font-weight: 500 !important;
          color: $label-text-color !important;
          margin-bottom: 8px !important;
        }
        
        .b-numberinput {
          width: 100% !important;
          
          .control {
            width: 100% !important;
            
            input {
              width: 100% !important;
              max-width: 100% !important;
              text-align: left !important;
              min-height: 48px !important;
              font-size: 16px !important;
              padding: 12px 16px !important;
              border: 1px solid $number-input-border !important;
              border-radius: 8px !important;
            }
          }
        }
        
        .timepicker {
          width: 100% !important;
          
          .dropdown-trigger {
            width: 100% !important;
            
            .control {
              width: 100% !important;
              
              input {
                width: 100% !important;
              }
            }
          }
        }
      }
    }
    
    // Hourly & Daily tabs mobile optimization
    .hourly-tab .card .field.has-addons,
    .daily-tab .card .field.has-addons {
      @media (max-width: $breakpoint-tablet-large) {
        display: flex !important;
        flex-direction: column !important;
        align-items: stretch !important;
        gap: 16px !important;
        
        .centered-text {
          width: 100% !important;
          text-align: left !important;
          font-size: 15px !important;
          font-weight: 500 !important;
          color: $label-text-color !important;
          margin-bottom: 8px !important;
        }
        
        .b-numberinput {
          width: 100% !important;
          
          .control {
            width: 100% !important;
            
            input {
              width: 100% !important;
              max-width: 100% !important;
              text-align: left !important;
              min-height: 48px !important;
              font-size: 16px !important;
              padding: 12px 16px !important;
              border: 1px solid $number-input-border !important;
              border-radius: 8px !important;
            }
          }
        }
        
        .timepicker {
          width: 100% !important;
          
          .dropdown-trigger {
            width: 100% !important;
            
            .control {
              width: 100% !important;
              
              input {
                width: 100% !important;
              }
            }
          }
        }
      }
    }
  }
}
</style>
